// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"284":"7c06a19a","286":"27a2c437","442":"406cb8cd","940":"e760a902"}[chunkId] + ".css";
};